/**
 * Protege las rutas del portal del asegurado cuando el flujo de registro está
 * encendido (INSURED_REGISTRATION_ENABLED, ver ./config.js):
 *  - sin sesión del asegurado → redirige a /asegurado/login;
 *  - con sesión → fuerza el `?ci=` de la URL a la cédula de la sesión, para
 *    que no se pueda consultar otra cédula cambiando la URL (el backend
 *    además lo valida).
 * Con el switch apagado renderiza la ruta sin cambios (flujo actual).
 */
import { Navigate, useLocation } from 'react-router-dom';

import { INSURED_REGISTRATION_ENABLED } from './config';
import { getInsuredToken, getInsuredUser } from './insuredAuthService';
import { normalizeCi } from '../utils/format';

export default function InsuredProtectedRoute({ children }) {
  const location = useLocation();

  if (!INSURED_REGISTRATION_ENABLED) return children;

  const user = getInsuredUser();
  if (!getInsuredToken() || !user) {
    return <Navigate to="/asegurado/login" replace />;
  }

  const params = new URLSearchParams(location.search);
  if (user.ci && normalizeCi(params.get('ci')) !== normalizeCi(user.ci)) {
    params.set('ci', user.ci);
    return <Navigate to={`${location.pathname}?${params.toString()}`} replace />;
  }

  return children;
}
